module.exports = Em.Handlebars.compile("<img {{bind-attr src=fixedSrc title=name}} class=\"image\" />\n");